module.exports = __webpack_public_path__ + "img/brambory-poster.759e3b53.jpg";